<div class="ts1-preview-summary" [class.ts1-preview-summary--embedded]="embedded">
	<div class="ts1-preview-summary__toolbar">
		<div class="ts1-preview-summary__title">{{ previewSummaryTitle }}</div>
	</div>

	<div class="ts1-preview-summary__candidate-nav" [class.ts1-preview-summary__candidate-nav--single]="hideCandidateNav">
		@if (!hideCandidateNav) {
			<button
				type="button"
				class="ts1-preview-summary__nav-btn ts1-preview-summary__nav-btn--prev"
				(click)="prevCandidate()"
				[disabled]="currentCandidateIndex === 0"
				aria-label="Previous candidate"
			>
				<span class="aa-mat-icon">chevron_left</span>
			</button>

			<div class="ts1-preview-summary__candidate-center">
				<div class="ts1-preview-summary__candidate-name">{{ currentName }}</div>
			</div>

			<button
				type="button"
				class="ts1-preview-summary__nav-btn ts1-preview-summary__nav-btn--next"
				(click)="nextCandidate()"
				[disabled]="currentCandidateIndex >= candidateNames.length - 1"
				aria-label="Next candidate"
			>
				<span class="aa-mat-icon">chevron_right</span>
			</button>
		} @else if (currentName) {
			<div class="ts1-preview-summary__candidate-center">
				<div class="ts1-preview-summary__candidate-name">{{ currentName }}</div>
			</div>
		}
	</div>

	<div class="ts1-preview-summary__body">
		@if (candidateDetails; as details) {
			<div class="ts1-preview-summary__meta">
				<div class="ts1-preview-summary__field">
					<div class="ts1-preview-summary__field-label">Training Date</div>
					<div class="ts1-preview-summary__field-value">{{ details.trainingDate }}</div>
				</div>
				<div class="ts1-preview-summary__field">
					<div class="ts1-preview-summary__field-label">Session Details</div>
					@if (showEts1SessionGrid && ets1SessionsGroup && ets1SessionRemarksGroup) {
						<div class="ts1-preview-summary__field-value ts1-preview-summary__ets1-sessions">
							<app-ets1-aoc-session-config
								[readOnly]="true"
								[sessions]="ets1SessionsGroup"
								[sessionRemarks]="ets1SessionRemarksGroup"
								[columns]="ets1SessionColumns"
							></app-ets1-aoc-session-config>
						</div>
					} @else {
						<div class="ts1-preview-summary__field-value">
							@if (ets1SelectedSessionConfigurations.length) {
								@for (cfg of ets1SelectedSessionConfigurations; track cfg.code ?? cfg.description; let last = $last) {
									<span>{{ cfg.description }}</span>
									@if (cfg.selectionRemarks) {
										<span> : {{ cfg.selectionRemarks }}</span>
									}
									@if (!last) {
										<span>, </span>
									}
								}
							} @else {
								—
							}
						</div>
					}
				</div>
			</div>

			<div class="ts1-preview-summary__section-header">Candidate Details</div>
			<div class="ts1-preview-summary__fields">
				<div class="ts1-preview-summary__field">
					<div class="ts1-preview-summary__field-label">Name</div>
					<div class="ts1-preview-summary__field-value">{{ details.name }}</div>
				</div>
				<div class="ts1-preview-summary__field">
					<div class="ts1-preview-summary__field-label">Rank</div>
					<div class="ts1-preview-summary__field-value">{{ details.rank }}</div>
				</div>
				<div class="ts1-preview-summary__field">
					<div class="ts1-preview-summary__field-label">Staff No.</div>
					<div class="ts1-preview-summary__field-value">{{ details.staffNumber }}</div>
				</div>
				<div class="ts1-preview-summary__field">
					<div class="ts1-preview-summary__field-label">Pilot Profile</div>
					<div class="ts1-preview-summary__field-value">{{ details.pilotProfile }}</div>
				</div>
				<div class="ts1-preview-summary__field">
					<div class="ts1-preview-summary__field-label">License Number, ATPL/CPL</div>
					<div class="ts1-preview-summary__field-value">{{ details.licenseNo }}</div>
				</div>
				<div class="ts1-preview-summary__field">
					<div class="ts1-preview-summary__field-label">License Type</div>
					<div class="ts1-preview-summary__field-value">{{ details.licenseType }}</div>
				</div>
				<div class="ts1-preview-summary__field">
					<div class="ts1-preview-summary__field-label">License Expiry Date</div>
					<div class="ts1-preview-summary__field-value">{{ details.licenseExpiryDate }}</div>
				</div>
			</div>

			<app-flight-simulator-summary-fields-v2
				[details]="details.flightSimulatorDetails"
				[useTs1V3FlightDetails]="true"
			/>
		}

		<app-ts1-rating-step3-review
			[readOnly]="true"
			[candidateNames]="candidateNames"
			[candidateCrewRoles]="candidateCrewRoles"
			[candidateIds]="candidateIds"
			[currentIndex]="currentCandidateIndex"
			[competencyBlocks]="competencyBlocks"
			[maneuverRows]="maneuverRows"
			[maneuverOutcomes]="maneuverOutcomes"
			[temCompetencyOutcomes]="temCompetencyOutcomes"
			[summaryComments]="summaryComments"
			[traineeAssessmentId]="traineeAssessmentId"
			[signOffControl]="signOffControl"
			[reminderNotesEnabled]="reminderNotesEnabled"
			[useStructuredReminderNotes]="useStructuredReminderNotes"
			[reminderNoteResponses]="reminderNoteResponses"
		></app-ts1-rating-step3-review>

		<div class="ts1-preview-summary__comments">
			<button
				type="button"
				class="ts1-preview-summary__comments-toggle"
				(click)="toggleComments()"
				[attr.aria-expanded]="commentsExpanded"
			>
				<span class="ts1-preview-summary__comments-heading">View Comments</span>
				<span class="aa-mat-icon ts1-preview-summary__comments-chevron">
					@if (commentsExpanded) {
						expand_less
					} @else {
						expand_more
					}
				</span>
			</button>
			@if (commentsExpanded) {
				<div class="ts1-preview-summary__comments-body">
					@if (previewCommentGroups.length === 0) {
						<span class="ts1-preview-summary__comments-empty">No summary comments.</span>
					} @else {
						@for (group of previewCommentGroups; track group.maneuverCode) {
							<div class="ts1-preview-summary__comment-group">
								<div class="ts1-preview-summary__comment-title">
									<span class="ts1-preview-summary__comment-code">{{ group.label }}</span>
								</div>
								@for (comment of group.comments; track $index) {
									<div class="ts1-preview-summary__comment-row">
										@if (comment.ob === "REPEAT") {
											<span class="ts1-preview-summary__comment-tag ts1-preview-summary__comment-tag--yellow">
												[ REPEAT ]
											</span>
										} @else if (comment.isObservationComment) {
											<span class="ts1-preview-summary__comment-tag ts1-preview-summary__comment-tag--neutral">
												[ {{ previewCommentPrimaryTagLabel(comment) }} ]
											</span>
										} @else {
											<span class="ts1-preview-summary__comment-tag" [ngClass]="previewCommentObTagClass(comment)">
												[ {{ previewCommentPrimaryTagLabel(comment) }} ]
											</span>
										}
										@if (previewCommentRoleLabel(comment.candidateRole); as roleLabel) {
											<span class="ts1-preview-summary__comment-role">[ {{ roleLabel }} ]</span>
										}
										@if (previewCommentNaSuffix(comment); as naSuffix) {
											<span class="ts1-preview-summary__comment-na-suffix">{{ naSuffix }}</span>
										}
										@if (previewCommentOutcomeRemarks(comment); as outcomeRemarks) {
											<span
												class="ts1-preview-summary__comment-remarks"
												[ngClass]="previewCommentOutcomeRateClass(comment.rate)"
											>
												{{ outcomeRemarks }}
											</span>
										}
										@if (hasInstructorComment(comment)) {
											<span class="ts1-preview-summary__comment-text">{{ comment.instructorComment }}</span>
										}
									</div>
								}
							</div>
						}
					}

					<div class="ts1-preview-summary__notes-block">
						<div class="ts1-preview-summary__notes-heading">General Observation</div>
						@if (generalObservationText) {
							<p class="ts1-preview-summary__notes-text">{{ generalObservationText }}</p>
						} @else {
							<span class="ts1-preview-summary__comments-empty">—</span>
						}
					</div>

					@if (reminderNotesEnabled && !useStructuredReminderNotes) {
						<div class="ts1-preview-summary__notes-block">
							<div class="ts1-preview-summary__notes-heading">Additional Training/Assessment Details</div>
							@if (reminderNotesText) {
								<p class="ts1-preview-summary__notes-text ts1-preview-summary__notes-text--uppercase">
									{{ reminderNotesText }}
								</p>
							} @else {
								<span class="ts1-preview-summary__comments-empty">—</span>
							}
						</div>
					}
				</div>
			}
		</div>
	</div>

	@if (!hideFooter) {
		<div class="ts1-preview-summary__footer">
			<button type="button" class="aa-btn" data-size="small" data-variant="tertiary" (click)="onBack()">Back</button>
			@if (checklistFooter) {
				<button type="button" class="aa-btn" data-size="small" data-variant="primary" (click)="onNext()">Next</button>
			} @else {
				<button type="button" class="aa-btn" data-size="small" data-variant="tertiary" (click)="onClose()">
					Close
				</button>
			}
		</div>
	}
</div>
